import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule as MatAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { Overlay } from '@angular/cdk/overlay';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';

import { TreoCardModule } from 'tsui/@treo';
import { PanelsComponent } from './panels.component';
import { PanelsDirective } from './panels.directive';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PanelsNotesComponent } from './notes/notes.component';
import { PanelsFormComponent } from './form/form.component';
import { PanelsImagesComponent } from './images/images.component';
import { PanelsMapComponent } from './map/map.component';
import { PanelsCommentsComponent } from './comments/comments.component';
import { PanelsTasksComponent } from './legacy-tasks/tasks.component';
import { PanelsFilesComponent } from './files/files.component';
import { PanelsDatesComponent } from './dates/dates.component';
import { PanelsSummaryComponent } from './summary/summary.component';
import { PanelsContactsComponent } from './contacts/contacts.component';
import { PanelsOffersComponent } from './offers/offers.component';
import { PanelsMailboxComponent } from './mailbox/mailbox.component';
import { PanelsNearbyComponent } from './nearby/nearby.component';
import { PanelsScenariosComponent } from './scenarios/scenarios.component';
import { ContactsModalModule } from 'app/modules/contacts/modals/modals.module';
import { PanelsDispositionsComponent } from './dispositions/dispositions.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { PanelsUnitsTableComponent } from './units-table/units-table.component';
import { PanelsPortfolioDetailComponent } from './portfolio-detail/portfolio-detail.component';
import { PanelHeaderComponent } from './@shared/panel-header/panel-header.component';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { TableComponent } from './table/table.component';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { environment } from '@env/environment';
import { ProjectsSharedModule } from 'app/modules/projects/@shared/projects-shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PanelsChartComponent } from './chart/chart.component';
import { TimeSeriesChartModule } from 'app/shared/modules/time-series-charts/time-series-chart/time-series-chart.module';
import { TsButtonModule, TsColorBubbleComponent } from 'tsui';
import { AddOfferComponent } from '../../offers/add-offer/add-offer.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { TsPipesModule } from 'tsui/lib/cross-cutting/pipes/ts-pipes.module';
import { AccountColorBackgroundDirective } from '@shared/directives/account-color-background.directive';
import { TsTableComponent } from 'tsui/lib/ts-table';
import { HasPermissionPipe } from '@shared/pipes/has-permission.pipe';
import { NgxsModule } from '@ngxs/store';
import { TaskState } from '@tasks/state/state';
import { RelatedTableCoreComponent } from '@shared/components/panels/components/related-table-core/related-table-core.component';

const STANDALONE_PANELS_COMPONENTS = [PanelsTasksComponent, RelatedTableCoreComponent];
@NgModule({
  declarations: [
    PanelsComponent,
    PanelsDirective,
    PanelsNotesComponent,
    PanelsFormComponent,
    PanelsImagesComponent,
    PanelsMapComponent,
    PanelsCommentsComponent,
    PanelsFilesComponent,
    PanelsDatesComponent,
    PanelsSummaryComponent,
    PanelsContactsComponent,
    PanelsOffersComponent,
    PanelsDispositionsComponent,
    PanelsNearbyComponent,
    PanelsMailboxComponent,
    PanelsUnitsTableComponent,
    PanelsPortfolioDetailComponent,
    TableComponent,
    PanelHeaderComponent,
    PanelsChartComponent,
    PanelsScenariosComponent,
  ],
  imports: [
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    DragDropModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatChipsModule,
    AddOfferComponent,
    ProjectsSharedModule,
    PipesModule,
    MatMomentDateModule,
    MatProgressBarModule,
    ContactsModalModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatSortModule,
    MatTabsModule,
    NgApexchartsModule,
    MatTooltipModule,
    MatExpansionModule,
    TreoAutogrowModule,
    MatAutocompleteModule,
    TreoFindByKeyPipeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GalleryModule,
    LightboxModule,
    TreoCardModule,
    SharedModule,
    CurrencyMaskModule,
    ColumnSelectorModule,
    MatPaginatorModule,
    DigitOnlyModule,
    ScrollingModule,
    NgxMapboxGLModule.withConfig({ accessToken: environment.mapbox.accessToken }),
    TimeSeriesChartModule,
    TsButtonModule,
    TsPipesModule,
    AccountColorBackgroundDirective,
    TsColorBubbleComponent,
    TsTableComponent,
    HasPermissionPipe,
    NgxsModule.forRoot([TaskState]),
    ...STANDALONE_PANELS_COMPONENTS,
  ],
  exports: [PanelsComponent],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class PanelsModule {}
